/** Dock width defaults and bounds (px). */
/** The dock header's frame buttons (Expand, Close, Ask about selection): one class so they stay the same height. */
export const FRAME_BTN =
  'text-muted-foreground hover:text-foreground hover:bg-muted rounded-md p-1.5 transition-colors';

export const DOCK_DEFAULT_WIDTH = 384; // ~1/3 on a typical desktop
export const DOCK_MIN_WIDTH = 320;
export const DOCK_MAX_WIDTH = 720;

/** localStorage key for the width of a given persist key. */
export const widthStorageKey = (persistKey: string) => `chatdock-${persistKey}-width`;

/** localStorage key for the open state of a given persist key. */
export const openStorageKey = (persistKey: string) => `chatdock-${persistKey}-open`;

/** localStorage key for the expanded (overlay) state of a given persist key. */
export const expandedStorageKey = (persistKey: string) => `chatdock-${persistKey}-expanded`;
